module.exports = __webpack_public_path__ + "media/images/flags/wf-e9a373c6bcbf8ea5021ff0ce24b72e06.svg";